import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
// Store
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { Observable, of as observableOf } from 'rxjs';

import { RiskModel } from '@amfam/policy/models';

import * as fromRoot from '../core/store';

@Injectable()
export class PolicyResolve {
  private riskDescription = '';
  private risks: Array<RiskModel> = new Array<RiskModel>();
  private currentRisk: RiskModel;

  constructor(private store: Store<fromRoot.RootState>) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.select(fromRoot.getReplaceVehicleRisks).subscribe(risks => {
      this.risks = risks;
      this.currentRisk = this.risks.find(risk => risk.vehicleId === route.params['id']);
      this.riskDescription = this.currentRisk ? this.currentRisk.description : '';
    });
    return observableOf(this.riskDescription);
  }
}
